import { Divider, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { UserContentLayout } from '../../components/Layouts/UserContentLayout';
import { useStoreContext } from '../../hooks/useStore';
import { ProfileHeader } from '../../components/User/Profile/ProfileHeader';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ProfileTabPreview } from '../../components/User/Profile/Tabs/ProfileTabPreview';
import { ProfileTabEdit } from '../../components/User/Profile/Tabs/ProfileTabEdit';

const UserProfile = () => {
  const { t } = useTranslation();
  const {
    store: { user },
  } = useStoreContext();
  const [tabIndex, setTabIndex] = useState<number>(0);

  return (
    <UserContentLayout caption={`${t('profile.caption')}`}>
      <ProfileHeader name={`${user?.firstName} ${user?.lastName}`} birthday={user?.birthday} avatar={user?.avatar} />

      <Divider />

      <Tabs index={tabIndex} isLazy={true}>
        <TabPanels>
          <TabPanel p={0}>
            <ProfileTabPreview onChangeTab={setTabIndex} />
          </TabPanel>

          <TabPanel p={0}>
            <ProfileTabEdit onChangeTab={setTabIndex} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </UserContentLayout>
  );
};

export default UserProfile;
